/**
 * PTEL Andalucía - Centroides de los 785 Municipios Andaluces
 * 
 * Generado automáticamente desde servicio WFS DERA (IECA)
 * Fuente: https://www.ideandalucia.es/services/DERA_g7_sistema_urbano/wfs
 * Capa: g07_01_Poblaciones (nivel='Cabecera municipal')
 * Sistema de coordenadas: EPSG:25830 (UTM 30N ETRS89)
 * 
 * Total municipios: 785
 * @version 1.0.0
 * @date Diciembre 2025
 */

export interface CentroideMunicipio {
  x: number;         // UTM X (EPSG:25830)
  y: number;         // UTM Y (EPSG:25830)
  nombre: string;    // Nombre del municipio
  provincia: string; // Provincia
}

/**
 * Centroides de cabeceras municipales de Andalucía
 * Indexado por código INE de 5 dígitos
 */
export const CENTROIDES_MUNICIPIOS: Record<string, CentroideMunicipio> = {
  '04001': { x: 519732, y: 4110718, nombre: 'Abla', provincia: 'Almería' },
  '04002': { x: 518113, y: 4109715, nombre: 'Abrucena', provincia: 'Almería' },
  '04003': { x: 498520, y: 4067033, nombre: 'Adra', provincia: 'Almería' },
  '04004': { x: 572421, y: 4126738, nombre: 'Albanchez', provincia: 'Almería' },
  '04005': { x: 533680, y: 4098594, nombre: 'Alboloduy', provincia: 'Almería' },
  '04006': { x: 576191, y: 4138053, nombre: 'Albox', provincia: 'Almería' },
  '04007': { x: 503411, y: 4091830, nombre: 'Alcolea', provincia: 'Almería' },
  '04008': { x: 535565, y: 4132151, nombre: 'Alcóntar', provincia: 'Almería' },
  '04009': { x: 565090, y: 4121255, nombre: 'Alcudia de Monteagud', provincia: 'Almería' },
  '04010': { x: 536801, y: 4093849, nombre: 'Alhabia', provincia: 'Almería' },
  '04011': { x: 538321, y: 4090215, nombre: 'Alhama de Almería', provincia: 'Almería' },
  '04012': { x: 535342, y: 4091339, nombre: 'Alicún', provincia: 'Almería' },
  '04013': { x: 547819, y: 4077614, nombre: 'Almería', provincia: 'Almería' },
  '04014': { x: 518667, y: 4095205, nombre: 'Almócita', provincia: 'Almería' },
  '04015': { x: 536088, y: 4095241, nombre: 'Alsodux', provincia: 'Almería' },
  '04016': { x: 595968, y: 4122627, nombre: 'Antas', provincia: 'Almería' },
  '04017': { x: 582013, y: 4134233, nombre: 'Arboleas', provincia: 'Almería' },
  '04018': { x: 552077, y: 4133848, nombre: 'Armuña de Almanzora', provincia: 'Almería' },
  '04019': { x: 548457, y: 4123880, nombre: 'Bacares', provincia: 'Almería' },
  '04020': { x: 500392, y: 4098243, nombre: 'Bayárcal', provincia: 'Almería' },
  '04021': { x: 549999, y: 4131658, nombre: 'Bayarque', provincia: 'Almería' },
  '04022': { x: 590470, y: 4116540, nombre: 'Bédar', provincia: 'Almería' },
  '04023': { x: 518546, y: 4096235, nombre: 'Beires', provincia: 'Almería' },
  '04024': { x: 548191, y: 4086796, nombre: 'Benahadux', provincia: 'Almería' },
  '04026': { x: 567547, y: 4120823, nombre: 'Benitagla', provincia: 'Almería' },
  '04027': { x: 567314, y: 4118657, nombre: 'Benizalón', provincia: 'Almería' },
  '04028': { x: 533846, y: 4093555, nombre: 'Bentarique', provincia: 'Almería' },
  '04029': { x: 503569, y: 4077015, nombre: 'Berja', provincia: 'Almería' },
  '04030': { x: 523099, y: 4095836, nombre: 'Canjáyar', provincia: 'Almería' },
  '04031': { x: 571739, y: 4134285, nombre: 'Cantoria', provincia: 'Almería' },
  '04032': { x: 598216, y: 4095226, nombre: 'Carboneras', provincia: 'Almería' },
  '04033': { x: 549676, y: 4115474, nombre: 'Castro de Filabres', provincia: 'Almería' },
  '04034': { x: 569971, y: 4124202, nombre: 'Cóbdar', provincia: 'Almería' },
  '04035': { x: 599242, y: 4128220, nombre: 'Cuevas del Almanzora', provincia: 'Almería' },
  '04036': { x: 565827, y: 4124761, nombre: 'Chercos', provincia: 'Almería' },
  '04037': { x: 563764, y: 4161329, nombre: 'Chirivel', provincia: 'Almería' },
  '04038': { x: 511489, y: 4075205, nombre: 'Dalías', provincia: 'Almería' },
  '04041': { x: 534977, y: 4081344, nombre: 'Enix', provincia: 'Almería' },
  '04043': { x: 530575, y: 4080403, nombre: 'Felix', provincia: 'Almería' },
  '04044': { x: 565201, y: 4135062, nombre: 'Fines', provincia: 'Almería' },
  '04045': { x: 513161, y: 4113682, nombre: 'Fiñana', provincia: 'Almería' },
  '04046': { x: 512657, y: 4092776, nombre: 'Fondón', provincia: 'Almería' },
  '04047': { x: 545510, y: 4089760, nombre: 'Gádor', provincia: 'Almería' },
  '04048': { x: 594077, y: 4114071, nombre: 'Los Gallardos', provincia: 'Almería' },
  '04049': { x: 604743, y: 4115798, nombre: 'Garrucha', provincia: 'Almería' },
  '04050': { x: 540812, y: 4108197, nombre: 'Gérgal', provincia: 'Almería' },
  '04051': { x: 534795, y: 4091302, nombre: 'Huécija', provincia: 'Almería' },
  '04052': { x: 549962, y: 4082211, nombre: 'Huércal de Almería', provincia: 'Almería' },
  '04053': { x: 593369, y: 4138833, nombre: 'Huércal-Overa', provincia: 'Almería' },
  '04054': { x: 532064, y: 4093445, nombre: 'Íllar', provincia: 'Almería' },
  '04055': { x: 530232, y: 4094127, nombre: 'Instinción', provincia: 'Almería' },
  '04056': { x: 559255, y: 4127942, nombre: 'Laroya', provincia: 'Almería' },
  '04057': { x: 509545, y: 4094246, nombre: 'Laujar de Andarax', provincia: 'Almería' },
  '04058': { x: 569307, y: 4127881, nombre: 'Líjar', provincia: 'Almería' },
  '04059': { x: 582817, y: 4119216, nombre: 'Lubrín', provincia: 'Almería' },
  '04060': { x: 571067, y: 4099714, nombre: 'Lucainena de las Torres', provincia: 'Almería' },
  '04061': { x: 550899, y: 4139470, nombre: 'Lúcar', provincia: 'Almería' },
  '04062': { x: 561726, y: 4131914, nombre: 'Macael', provincia: 'Almería' },
  '04063': { x: 573567, y: 4174035, nombre: 'María', provincia: 'Almería' },
  '04064': { x: 602166, y: 4111034, nombre: 'Mojácar', provincia: 'Almería' },
  '04065': { x: 531172, y: 4106745, nombre: 'Nacimiento', provincia: 'Almería' },
  '04066': { x: 570666, y: 4091154, nombre: 'Níjar', provincia: 'Almería' },
  '04067': { x: 522622, y: 4099186, nombre: 'Ohanes', provincia: 'Almería' },
  '04068': { x: 546572, y: 4114382, nombre: 'Olula de Castro', provincia: 'Almería' },
  '04069': { x: 562151, y: 4134592, nombre: 'Olula del Río', provincia: 'Almería' },
  '04070': { x: 562555, y: 4148878, nombre: 'Oria', provincia: 'Almería' },
  '04071': { x: 520063, y: 4094798, nombre: 'Padules', provincia: 'Almería' },
  '04072': { x: 568440, y: 4139990, nombre: 'Partaloa', provincia: 'Almería' },
  '04073': { x: 504157, y: 4097386, nombre: 'Paterna del Río', provincia: 'Almería' },
  '04074': { x: 550019, y: 4085874, nombre: 'Pechina', provincia: 'Almería' },
  '04075': { x: 610899, y: 4140860, nombre: 'Pulpí', provincia: 'Almería' },
  '04076': { x: 556590, y: 4133510, nombre: 'Purchena', provincia: 'Almería' },
  '04077': { x: 528346, y: 4094375, nombre: 'Rágol', provincia: 'Almería' },
  '04078': { x: 547509, y: 4089130, nombre: 'Rioja', provincia: 'Almería' },
  '04079': { x: 533078, y: 4067774, nombre: 'Roquetas de Mar', provincia: 'Almería' },
  '04080': { x: 535265, y: 4096983, nombre: 'Santa Cruz de Marchena', provincia: 'Almería' },
  '04081': { x: 541681, y: 4092121, nombre: 'Santa Fe de Mondújar', provincia: 'Almería' },
  '04082': { x: 558032, y: 4117727, nombre: 'Senés', provincia: 'Almería' },
  '04083': { x: 543472, y: 4133152, nombre: 'Serón', provincia: 'Almería' },
  '04084': { x: 553232, y: 4130701, nombre: 'Sierro', provincia: 'Almería' },
  '04085': { x: 553679, y: 4138759, nombre: 'Somontín', provincia: 'Almería' },
  '04086': { x: 577711, y: 4106189, nombre: 'Sorbas', provincia: 'Almería' },
  '04087': { x: 554161, y: 4132615, nombre: 'Suflí', provincia: 'Almería' },
  '04088': { x: 554101, y: 4100801, nombre: 'Tabernas', provincia: 'Almería' },
  '04089': { x: 581561, y: 4146962, nombre: 'Taberno', provincia: 'Almería' },
  '04090': { x: 563431, y: 4120428, nombre: 'Tahal', provincia: 'Almería' },
  '04091': { x: 535876, y: 4093236, nombre: 'Terque', provincia: 'Almería' },
  '04092': { x: 549933, y: 4133324, nombre: 'Tíjola', provincia: 'Almería' },
  '04093': { x: 598133, y: 4112333, nombre: 'Turre', provincia: 'Almería' },
  '04094': { x: 565401, y: 4098381, nombre: 'Turrillas', provincia: 'Almería' },
  '04095': { x: 570621, y: 4115716, nombre: 'Uleila del Campo', provincia: 'Almería' },
  '04096': { x: 556239, y: 4138741, nombre: 'Urrácal', provincia: 'Almería' },
  '04097': { x: 553024, y: 4116575, nombre: 'Velefique', provincia: 'Almería' },
  '04098': { x: 579698, y: 4172036, nombre: 'Vélez-Blanco', provincia: 'Almería' },
  '04099': { x: 581583, y: 4167196, nombre: 'Vélez-Rubio', provincia: 'Almería' },
  '04100': { x: 600392, y: 4122788, nombre: 'Vera', provincia: 'Almería' },
  '04101': { x: 551260, y: 4082609, nombre: 'Viator', provincia: 'Almería' },
  '04102': { x: 531382, y: 4072907, nombre: 'Vícar', provincia: 'Almería' },
  '04103': { x: 585010, y: 4133243, nombre: 'Zurgena', provincia: 'Almería' },
  '04901': { x: 525584, y: 4109930, nombre: 'Las Tres Villas', provincia: 'Almería' },
  '04902': { x: 516671, y: 4069590, nombre: 'El Ejido', provincia: 'Almería' },
  '04903': { x: 528284, y: 4067551, nombre: 'La Mojonera', provincia: 'Almería' },
  '04904': { x: 508054, y: 4067109, nombre: 'Balanegra', provincia: 'Almería' },
  '11001': { x: 255881, y: 4038608, nombre: 'Alcalá de los Gazules', provincia: 'Cádiz' },
  '11002': { x: 306563, y: 4086530, nombre: 'Alcalá del Valle', provincia: 'Cádiz' },
  '11003': { x: 262608, y: 4060132, nombre: 'Algar', provincia: 'Cádiz' },
  '11004': { x: 278780, y: 4001665, nombre: 'Algeciras', provincia: 'Cádiz' },
  '11005': { x: 285714, y: 4084267, nombre: 'Algodonales', provincia: 'Cádiz' },
  '11006': { x: 249362, y: 4070732, nombre: 'Arcos de la Frontera', provincia: 'Cádiz' },
  '11007': { x: 237730, y: 4009238, nombre: 'Barbate', provincia: 'Cádiz' },
  '11008': { x: 276062, y: 4007165, nombre: 'Los Barrios', provincia: 'Cádiz' },
  '11009': { x: 283711, y: 4064337, nombre: 'Benaocaz', provincia: 'Cádiz' },
  '11010': { x: 255375, y: 4077978, nombre: 'Bornos', provincia: 'Cádiz' },
  '11011': { x: 276365, y: 4070918, nombre: 'El Bosque', provincia: 'Cádiz' },
  '11012': { x: 206247, y: 4046803, nombre: 'Cádiz', provincia: 'Cádiz' },
  '11013': { x: 282733, y: 4018255, nombre: 'Castellar de la Frontera', provincia: 'Cádiz' },
  '11014': { x: 222662, y: 4019547, nombre: 'Conil de la Frontera', provincia: 'Cádiz' },
  '11015': { x: 216943, y: 4034173, nombre: 'Chiclana de la Frontera', provincia: 'Cádiz' },
  '11016': { x: 193594, y: 4070778, nombre: 'Chipiona', provincia: 'Cádiz' },
  '11017': { x: 249959, y: 4084394, nombre: 'Espera', provincia: 'Cádiz' },
  '11018': { x: 292944, y: 4081387, nombre: 'El Gastor', provincia: 'Cádiz' },
  '11019': { x: 288649, y: 4070792, nombre: 'Grazalema', provincia: 'Cádiz' },
  '11020': { x: 218271, y: 4062004, nombre: 'Jerez de la Frontera', provincia: 'Cádiz' },
  '11021': { x: 280227, y: 4034720, nombre: 'Jimena de la Frontera', provincia: 'Cádiz' },
  '11022': { x: 289212, y: 4005595, nombre: 'La Línea de la Concepción', provincia: 'Cádiz' },
  '11023': { x: 237378, y: 4039177, nombre: 'Medina Sidonia', provincia: 'Cádiz' },
  '11024': { x: 298478, y: 4089936, nombre: 'Olvera', provincia: 'Cádiz' },
  '11025': { x: 243385, y: 4045815, nombre: 'Paterna de Rivera', provincia: 'Cádiz' },
  '11026': { x: 271840, y: 4074303, nombre: 'Prado del Rey', provincia: 'Cádiz' },
  '11027': { x: 210910, y: 4055128, nombre: 'El Puerto de Santa María', provincia: 'Cádiz' },
  '11028': { x: 215167, y: 4047642, nombre: 'Puerto Real', provincia: 'Cádiz' },
  '11029': { x: 273487, y: 4089455, nombre: 'Puerto Serrano', provincia: 'Cádiz' },
  '11030': { x: 198981, y: 4058658, nombre: 'Rota', provincia: 'Cádiz' },
  '11031': { x: 212569, y: 4038789, nombre: 'San Fernando', provincia: 'Cádiz' },
  '11032': { x: 200935, y: 4075087, nombre: 'Sanlúcar de Barrameda', provincia: 'Cádiz' },
  '11033': { x: 285204, y: 4010122, nombre: 'San Roque', provincia: 'Cádiz' },
  '11034': { x: 305736, y: 4081839, nombre: 'Setenil de las Bodegas', provincia: 'Cádiz' },
  '11035': { x: 265255, y: 3988643, nombre: 'Tarifa', provincia: 'Cádiz' },
  '11036': { x: 300873, y: 4087795, nombre: 'Torre Alháquime', provincia: 'Cádiz' },
  '11037': { x: 216880, y: 4085230, nombre: 'Trebujena', provincia: 'Cádiz' },
  '11038': { x: 281109, y: 4059859, nombre: 'Ubrique', provincia: 'Cádiz' },
  '11039': { x: 233511, y: 4015862, nombre: 'Vejer de la Frontera', provincia: 'Cádiz' },
  '11040': { x: 286912, y: 4063827, nombre: 'Villaluenga del Rosario', provincia: 'Cádiz' },
  '11041': { x: 264400, y: 4082570, nombre: 'Villamartín', provincia: 'Cádiz' },
  '11042': { x: 286706, y: 4079878, nombre: 'Zahara', provincia: 'Cádiz' },
  '11901': { x: 247575, y: 4025602, nombre: 'Benalup-Casas Viejas', provincia: 'Cádiz' },
  '11902': { x: 249382, y: 4054738, nombre: 'San José del Valle', provincia: 'Cádiz' },
  '11903': { x: 291703, y: 4024326, nombre: 'San Martín del Tesorillo', provincia: 'Cádiz' },
  '14001': { x: 366293, y: 4210042, nombre: 'Adamuz', provincia: 'Córdoba' },
  '14002': { x: 352974, y: 4152558, nombre: 'Aguilar de la Frontera', provincia: 'Córdoba' },
  '14003': { x: 327738, y: 4250323, nombre: 'Alcaracejos', provincia: 'Córdoba' },
  '14004': { x: 403518, y: 4144260, nombre: 'Almedinilla', provincia: 'Córdoba' },
  '14005': { x: 322288, y: 4186983, nombre: 'Almodóvar del Río', provincia: 'Córdoba' },
  '14006': { x: 334239, y: 4253126, nombre: 'Añora', provincia: 'Córdoba' },
  '14007': { x: 383147, y: 4164090, nombre: 'Baena', provincia: 'Córdoba' },
  '14008': { x: 311256, y: 4271964, nombre: 'Belalcázar', provincia: 'Córdoba' },
  '14009': { x: 306849, y: 4238372, nombre: 'Belmez', provincia: 'Córdoba' },
  '14010': { x: 363489, y: 4125814, nombre: 'Benamejí', provincia: 'Córdoba' },
  '14011': { x: 287053, y: 4253742, nombre: 'Los Blázquez', provincia: 'Córdoba' },
  '14012': { x: 378518, y: 4195089, nombre: 'Bujalance', provincia: 'Córdoba' },
  '14013': { x: 372960, y: 4148184, nombre: 'Cabra', provincia: 'Córdoba' },
  '14014': { x: 383930, y: 4191939, nombre: 'Cañete de las Torres', provincia: 'Córdoba' },
  '14015': { x: 387252, y: 4144916, nombre: 'Carcabuey', provincia: 'Córdoba' },
  '14016': { x: 384208, y: 4236656, nombre: 'Cardeña', provincia: 'Córdoba' },
  '14017': { x: 329534, y: 4171013, nombre: 'La Carlota', provincia: 'Córdoba' },
  '14018': { x: 368609, y: 4200178, nombre: 'El Carpio', provincia: 'Córdoba' },
  '14019': { x: 369458, y: 4172618, nombre: 'Castro del Río', provincia: 'Córdoba' },
  '14020': { x: 368994, y: 4252236, nombre: 'Conquista', provincia: 'Córdoba' },
  '14021': { x: 342333, y: 4196689, nombre: 'Córdoba', provincia: 'Córdoba' },
  '14022': { x: 380132, y: 4157137, nombre: 'Doña Mencía', provincia: 'Córdoba' },
  '14023': { x: 334671, y: 4256850, nombre: 'Dos Torres', provincia: 'Córdoba' },
  '14024': { x: 367953, y: 4126245, nombre: 'Encinas Reales', provincia: 'Córdoba' },
  '14025': { x: 362637, y: 4170745, nombre: 'Espejo', provincia: 'Córdoba' },
  '14026': { x: 323173, y: 4228705, nombre: 'Espiel', provincia: 'Córdoba' },
  '14027': { x: 347877, y: 4170777, nombre: 'Fernán-Núñez', provincia: 'Córdoba' },
  '14028': { x: 321274, y: 4254694, nombre: 'Fuente la Lancha', provincia: 'Córdoba' },
  '14029': { x: 288198, y: 4238220, nombre: 'Fuente Obejuna', provincia: 'Córdoba' },
  '14030': { x: 314711, y: 4175148, nombre: 'Fuente Palmera', provincia: 'Córdoba' },
  '14031': { x: 398710, y: 4152088, nombre: 'Fuente-Tójar', provincia: 'Córdoba' },
  '14032': { x: 294555, y: 4249570, nombre: 'La Granjuela', provincia: 'Córdoba' },
  '14033': { x: 328829, y: 4180712, nombre: 'Guadalcázar', provincia: 'Córdoba' },
  '14034': { x: 344562, y: 4262366, nombre: 'El Guijo', provincia: 'Córdoba' },
  '14035': { x: 312209, y: 4262430, nombre: 'Hinojosa del Duque', provincia: 'Córdoba' },
  '14036': { x: 302212, y: 4189565, nombre: 'Hornachuelos', provincia: 'Córdoba' },
  '14037': { x: 384167, y: 4124172, nombre: 'Iznájar', provincia: 'Córdoba' },
  '14038': { x: 368101, y: 4141354, nombre: 'Lucena', provincia: 'Córdoba' },
  '14039': { x: 387056, y: 4157583, nombre: 'Luque', provincia: 'Córdoba' },
  '14040': { x: 345524, y: 4160845, nombre: 'Montalbán de Córdoba', provincia: 'Córdoba' },
  '14041': { x: 350230, y: 4168128, nombre: 'Montemayor', provincia: 'Córdoba' },
  '14042': { x: 355016, y: 4160996, nombre: 'Montilla', provincia: 'Córdoba' },
  '14043': { x: 378640, y: 4208967, nombre: 'Montoro', provincia: 'Córdoba' },
  '14044': { x: 360290, y: 4148367, nombre: 'Monturque', provincia: 'Córdoba' },
  '14045': { x: 357690, y: 4144385, nombre: 'Moriles', provincia: 'Córdoba' },
  '14046': { x: 370430, y: 4160817, nombre: 'Nueva Carteya', provincia: 'Córdoba' },
  '14047': { x: 342273, y: 4222026, nombre: 'Obejo', provincia: 'Córdoba' },
  '14048': { x: 359629, y: 4123538, nombre: 'Palenciana', provincia: 'Córdoba' },
  '14049': { x: 298870, y: 4174816, nombre: 'Palma del Río', provincia: 'Córdoba' },
  '14050': { x: 372037, y: 4203089, nombre: 'Pedro Abad', provincia: 'Córdoba' },
  '14051': { x: 346204, y: 4254796, nombre: 'Pedroche', provincia: 'Córdoba' },
  '14052': { x: 300516, y: 4242895, nombre: 'Peñarroya-Pueblonuevo', provincia: 'Córdoba' },
  '14053': { x: 314409, y: 4185843, nombre: 'Posadas', provincia: 'Córdoba' },
  '14054': { x: 338713, y: 4249183, nombre: 'Pozoblanco', provincia: 'Córdoba' },
  '14055': { x: 393939, y: 4144209, nombre: 'Priego de Córdoba', provincia: 'Córdoba' },
  '14056': { x: 342254, y: 4138950, nombre: 'Puente Genil', provincia: 'Córdoba' },
  '14057': { x: 346448, y: 4163645, nombre: 'La Rambla', provincia: 'Córdoba' },
  '14058': { x: 378728, y: 4131789, nombre: 'Rute', provincia: 'Córdoba' },
  '14059': { x: 339168, y: 4168982, nombre: 'San Sebastián de los Ballesteros', provincia: 'Córdoba' },
  '14060': { x: 337124, y: 4158905, nombre: 'Santaella', provincia: 'Córdoba' },
  '14061': { x: 334185, y: 4273714, nombre: 'Santa Eufemia', provincia: 'Córdoba' },
  '14062': { x: 353670, y: 4259685, nombre: 'Torrecampo', provincia: 'Córdoba' },
  '14063': { x: 392448, y: 4181566, nombre: 'Valenzuela', provincia: 'Córdoba' },
  '14064': { x: 294671, y: 4253499, nombre: 'Valsequillo', provincia: 'Córdoba' },
  '14065': { x: 336429, y: 4171328, nombre: 'La Victoria', provincia: 'Córdoba' },
  '14066': { x: 386353, y: 4204050, nombre: 'Villa del Río', provincia: 'Córdoba' },
  '14067': { x: 364169, y: 4202793, nombre: 'Villafranca de Córdoba', provincia: 'Córdoba' },
  '14068': { x: 333282, y: 4222969, nombre: 'Villaharta', provincia: 'Córdoba' },
  '14069': { x: 357820, y: 4242743, nombre: 'Villanueva de Córdoba', provincia: 'Córdoba' },
  '14070': { x: 325329, y: 4251383, nombre: 'Villanueva del Duque', provincia: 'Córdoba' },
  '14071': { x: 311520, y: 4229992, nombre: 'Villanueva del Rey', provincia: 'Córdoba' },
  '14072': { x: 326903, y: 4258216, nombre: 'Villaralto', provincia: 'Córdoba' },
  '14073': { x: 323240, y: 4216206, nombre: 'Villaviciosa de Córdoba', provincia: 'Córdoba' },
  '14074': { x: 329478, y: 4261324, nombre: 'El Viso', provincia: 'Córdoba' },
  '14075': { x: 383837, y: 4155977, nombre: 'Zuheros', provincia: 'Córdoba' },
  '14901': { x: 309855, y: 4171423, nombre: 'Fuente Carreteros', provincia: 'Córdoba' },
  '14902': { x: 335403, y: 4167301, nombre: 'La Guijarrosa', provincia: 'Córdoba' },
  '18001': { x: 426228, y: 4098512, nombre: 'Agrón', provincia: 'Granada' },
  '18002': { x: 478371, y: 4159364, nombre: 'Alamedilla', provincia: 'Granada' },
  '18003': { x: 441625, y: 4120726, nombre: 'Albolote', provincia: 'Granada' },
  '18004': { x: 481052, y: 4075785, nombre: 'Albondón', provincia: 'Granada' },
  '18005': { x: 488091, y: 4119997, nombre: 'Albuñán', provincia: 'Granada' },
  '18006': { x: 481980, y: 4071835, nombre: 'Albuñol', provincia: 'Granada' },
  '18007': { x: 444096, y: 4087073, nombre: 'Albuñuelas', provincia: 'Granada' },
  '18010': { x: 493545, y: 4112633, nombre: 'Aldeire', provincia: 'Granada' },
  '18011': { x: 449840, y: 4121322, nombre: 'Alfacar', provincia: 'Granada' },
  '18012': { x: 397578, y: 4131641, nombre: 'Algarinejo', provincia: 'Granada' },
  '18013': { x: 411998, y: 4095833, nombre: 'Alhama de Granada', provincia: 'Granada' },
  '18014': { x: 442774, y: 4107009, nombre: 'Alhendín', provincia: 'Granada' },
  '18015': { x: 487838, y: 4162416, nombre: 'Alicún de Ortega', provincia: 'Granada' },
  '18016': { x: 473261, y: 4084082, nombre: 'Almegíjar', provincia: 'Granada' },
  '18017': { x: 437668, y: 4066100, nombre: 'Almuñécar', provincia: 'Granada' },
  '18018': { x: 489729, y: 4114687, nombre: 'Alquife', provincia: 'Granada' },
  '18020': { x: 420472, y: 4090660, nombre: 'Arenas del Rey', provincia: 'Granada' },
  '18021': { x: 444912, y: 4111109, nombre: 'Armilla', provincia: 'Granada' },
  '18022': { x: 438994, y: 4119870, nombre: 'Atarfe', provincia: 'Granada' },
  '18023': { x: 519702, y: 4148894, nombre: 'Baza', provincia: 'Granada' },
  '18024': { x: 457323, y: 4119376, nombre: 'Beas de Granada', provincia: 'Granada' },
  '18025': { x: 481742, y: 4125974, nombre: 'Beas de Guadix', provincia: 'Granada' },
  '18027': { x: 485608, y: 4134067, nombre: 'Benalúa', provincia: 'Granada' },
  '18028': { x: 439573, y: 4142582, nombre: 'Benalúa de las Villas', provincia: 'Granada' },
  '18029': { x: 526490, y: 4162294, nombre: 'Benamaurel', provincia: 'Granada' },
  '18030': { x: 482976, y: 4092060, nombre: 'Bérchules', provincia: 'Granada' },
  '18032': { x: 468376, y: 4089284, nombre: 'Bubión', provincia: 'Granada' },
  '18033': { x: 473812, y: 4088004, nombre: 'Busquístar', provincia: 'Granada' },
  '18034': { x: 418576, y: 4101861, nombre: 'Cacín', provincia: 'Granada' },
  '18035': { x: 484050, y: 4088825, nombre: 'Cádiar', provincia: 'Granada' },
  '18036': { x: 449266, y: 4109579, nombre: 'Cájar', provincia: 'Granada' },
  '18037': { x: 445137, y: 4125351, nombre: 'Calicasas', provincia: 'Granada' },
  '18038': { x: 445335, y: 4148663, nombre: 'Campotéjar', provincia: 'Granada' },
  '18039': { x: 524419, y: 4143243, nombre: 'Caniles', provincia: 'Granada' },
  '18040': { x: 461915, y: 4086775, nombre: 'Cáñar', provincia: 'Granada' },
  '18042': { x: 468053, y: 4090632, nombre: 'Capileira', provincia: 'Granada' },
  '18043': { x: 463591, y: 4086415, nombre: 'Carataunas', provincia: 'Granada' },
  '18044': { x: 477377, y: 4087302, nombre: 'Cástaras', provincia: 'Granada' },
  '18045': { x: 531501, y: 4174575, nombre: 'Castilléjar', provincia: 'Granada' },
  '18046': { x: 519316, y: 4183213, nombre: 'Castril', provincia: 'Granada' },
  '18047': { x: 452161, y: 4112865, nombre: 'Cenes de la Vega', provincia: 'Granada' },
  '18048': { x: 428223, y: 4117348, nombre: 'Cijuela', provincia: 'Granada' },
  '18049': { x: 485747, y: 4119817, nombre: 'Cogollos de Guadix', provincia: 'Granada' },
  '18050': { x: 449218, y: 4125548, nombre: 'Cogollos de la Vega', provincia: 'Granada' },
  '18051': { x: 436865, y: 4136333, nombre: 'Colomera', provincia: 'Granada' },
  '18053': { x: 520225, y: 4167533, nombre: 'Cortes de Baza', provincia: 'Granada' },
  '18054': { x: 480382, y: 4128540, nombre: 'Cortes y Graena', provincia: 'Granada' },
  '18056': { x: 537254, y: 4159882, nombre: 'Cúllar', provincia: 'Granada' },
  '18057': { x: 440509, y: 4112192, nombre: 'Cúllar Vega', provincia: 'Granada' },
  '18059': { x: 431442, y: 4117320, nombre: 'Chauchina', provincia: 'Granada' },
  '18061': { x: 426997, y: 4109651, nombre: 'Chimeneas', provincia: 'Granada' },
  '18062': { x: 442899, y: 4111270, nombre: 'Churriana de la Vega', provincia: 'Granada' },
  '18063': { x: 474058, y: 4133757, nombre: 'Darro', provincia: 'Granada' },
  '18064': { x: 490830, y: 4160258, nombre: 'Dehesas de Guadix', provincia: 'Granada' },
  '18065': { x: 451260, y: 4147592, nombre: 'Dehesas Viejas', provincia: 'Granada' },
  '18066': { x: 447423, y: 4131258, nombre: 'Deifontes', provincia: 'Granada' },
  '18067': { x: 470569, y: 4130512, nombre: 'Diezma', provincia: 'Granada' },
  '18068': { x: 446689, y: 4103100, nombre: 'Dílar', provincia: 'Granada' },
  '18069': { x: 500787, y: 4114782, nombre: 'Dólar', provincia: 'Granada' },
  '18070': { x: 457095, y: 4115659, nombre: 'Dúdar', provincia: 'Granada' },
  '18071': { x: 449650, y: 4093436, nombre: 'Dúrcal', provincia: 'Granada' },
  '18072': { x: 432287, y: 4102053, nombre: 'Escúzar', provincia: 'Granada' },
  '18074': { x: 496873, y: 4113976, nombre: 'Ferreira', provincia: 'Granada' },
  '18076': { x: 484349, y: 4140704, nombre: 'Fonelas', provincia: 'Granada' },
  '18077': { x: 423695, y: 4090219, nombre: 'Fornes', provincia: 'Granada' },
  '18078': { x: 508116, y: 4153516, nombre: 'Freila', provincia: 'Granada' },
  '18079': { x: 430418, y: 4119540, nombre: 'Fuente Vaqueros', provincia: 'Granada' },
  '18082': { x: 539470, y: 4177346, nombre: 'Galera', provincia: 'Granada' },
  '18083': { x: 471620, y: 4147880, nombre: 'Gobernador', provincia: 'Granada' },
  '18084': { x: 446404, y: 4106673, nombre: 'Gójar', provincia: 'Granada' },
  '18085': { x: 502671, y: 4135827, nombre: 'Gor', provincia: 'Granada' },
  '18086': { x: 496376, y: 4147975, nombre: 'Gorafe', provincia: 'Granada' },
  '18087': { x: 445587, y: 4113795, nombre: 'Granada', provincia: 'Granada' },
  '18088': { x: 464768, y: 4156832, nombre: 'Guadahortuna', provincia: 'Granada' },
  '18089': { x: 487718, y: 4127983, nombre: 'Guadix', provincia: 'Granada' },
  '18093': { x: 468088, y: 4064453, nombre: 'Gualchos', provincia: 'Granada' },
  '18094': { x: 460919, y: 4112648, nombre: 'Güéjar Sierra', provincia: 'Granada' },
  '18095': { x: 447166, y: 4123638, nombre: 'Güevéjar', provincia: 'Granada' },
  '18096': { x: 476790, y: 4141515, nombre: 'Huélago', provincia: 'Granada' },
  '18097': { x: 504462, y: 4114398, nombre: 'Huéneja', provincia: 'Granada' },
  '18098': { x: 540319, y: 4184573, nombre: 'Huéscar', provincia: 'Granada' },
  '18099': { x: 454379, y: 4119680, nombre: 'Huétor de Santillán', provincia: 'Granada' },
  '18100': { x: 406926, y: 4117195, nombre: 'Huétor Tájar', provincia: 'Granada' },
  '18101': { x: 449502, y: 4111376, nombre: 'Huétor Vega', provincia: 'Granada' },
  '18102': { x: 422102, y: 4127164, nombre: 'Íllora', provincia: 'Granada' },
  '18103': { x: 442906, y: 4072789, nombre: 'Ítrabo', provincia: 'Granada' },
  '18105': { x: 453293, y: 4138537, nombre: 'Iznalloz', provincia: 'Granada' },
  '18106': { x: 418884, y: 4088088, nombre: 'Játar', provincia: 'Granada' },
  '18107': { x: 426891, y: 4089547, nombre: 'Jayena', provincia: 'Granada' },
  '18108': { x: 485810, y: 4115252, nombre: 'Jérez del Marquesado', provincia: 'Granada' },
  '18109': { x: 440402, y: 4072410, nombre: 'Jete', provincia: 'Granada' },
  '18111': { x: 447409, y: 4119440, nombre: 'Jun', provincia: 'Granada' },
  '18112': { x: 480030, y: 4089218, nombre: 'Juviles', provincia: 'Granada' },
  '18114': { x: 494391, y: 4115048, nombre: 'La Calahorra', provincia: 'Granada' },
  '18115': { x: 425863, y: 4116956, nombre: 'Láchar', provincia: 'Granada' },
  '18116': { x: 457025, y: 4086041, nombre: 'Lanjarón', provincia: 'Granada' },
  '18117': { x: 487714, y: 4113597, nombre: 'Lanteira', provincia: 'Granada' },
  '18119': { x: 450857, y: 4089202, nombre: 'Lecrín', provincia: 'Granada' },
  '18120': { x: 439895, y: 4076887, nombre: 'Lentegí', provincia: 'Granada' },
  '18121': { x: 481058, y: 4087004, nombre: 'Lobras', provincia: 'Granada' },
  '18122': { x: 397821, y: 4113869, nombre: 'Loja', provincia: 'Granada' },
  '18123': { x: 478644, y: 4120411, nombre: 'Lugros', provincia: 'Granada' },
  '18124': { x: 463960, y: 4071321, nombre: 'Lújar', provincia: 'Granada' },
  '18126': { x: 435800, y: 4106039, nombre: 'La Malahá', provincia: 'Granada' },
  '18127': { x: 443710, y: 4118273, nombre: 'Maracena', provincia: 'Granada' },
  '18128': { x: 481981, y: 4127872, nombre: 'Marchal', provincia: 'Granada' },
  '18132': { x: 430406, y: 4132964, nombre: 'Moclín', provincia: 'Granada' },
  '18133': { x: 445580, y: 4071408, nombre: 'Molvízar', provincia: 'Granada' },
  '18134': { x: 452084, y: 4109666, nombre: 'Monachil', provincia: 'Granada' },
  '18135': { x: 410713, y: 4131005, nombre: 'Montefrío', provincia: 'Granada' },
  '18136': { x: 455585, y: 4158475, nombre: 'Montejícar', provincia: 'Granada' },
  '18137': { x: 440461, y: 4150757, nombre: 'Montillana', provincia: 'Granada' },
  '18138': { x: 414263, y: 4113936, nombre: 'Moraleda de Zafayona', provincia: 'Granada' },
  '18140': { x: 453742, y: 4066964, nombre: 'Motril', provincia: 'Granada' },
  '18141': { x: 490272, y: 4082276, nombre: 'Murtas', provincia: 'Granada' },
  '18143': { x: 452082, y: 4092761, nombre: 'Nigüelas', provincia: 'Granada' },
  '18144': { x: 449005, y: 4123972, nombre: 'Nívar', provincia: 'Granada' },
  '18145': { x: 445711, y: 4108264, nombre: 'Ogíjares', provincia: 'Granada' },
  '18146': { x: 545918, y: 4174889, nombre: 'Orce', provincia: 'Granada' },
  '18147': { x: 462396, y: 4083962, nombre: 'Órgiva', provincia: 'Granada' },
  '18148': { x: 439368, y: 4074633, nombre: 'Otívar', provincia: 'Granada' },
  '18149': { x: 444046, y: 4104949, nombre: 'Villa de Otura', provincia: 'Granada' },
  '18150': { x: 444462, y: 4097647, nombre: 'Padul', provincia: 'Granada' },
  '18151': { x: 467906, y: 4088325, nombre: 'Pampaneira', provincia: 'Granada' },
  '18152': { x: 479581, y: 4150651, nombre: 'Pedro Martínez', provincia: 'Granada' },
  '18153': { x: 444454, y: 4120988, nombre: 'Peligros', provincia: 'Granada' },
  '18154': { x: 474776, y: 4125552, nombre: 'La Peza', provincia: 'Granada' },
  '18157': { x: 455330, y: 4113089, nombre: 'Pinos Genil', provincia: 'Granada' },
  '18158': { x: 433658, y: 4123101, nombre: 'Pinos Puente', provincia: 'Granada' },
  '18159': { x: 461135, y: 4144137, nombre: 'Píñar', provincia: 'Granada' },
  '18161': { x: 479280, y: 4123495, nombre: 'Polícar', provincia: 'Granada' },
  '18162': { x: 475143, y: 4066804, nombre: 'Polopos', provincia: 'Granada' },
  '18163': { x: 472310, y: 4088472, nombre: 'Pórtugos', provincia: 'Granada' },
  '18164': { x: 549542, y: 4201347, nombre: 'Puebla de Don Fadrique', provincia: 'Granada' },
  '18165': { x: 446207, y: 4119733, nombre: 'Pulianas', provincia: 'Granada' },
  '18167': { x: 483388, y: 4130128, nombre: 'Purullena', provincia: 'Granada' },
  '18168': { x: 458688, y: 4116366, nombre: 'Quéntar', provincia: 'Granada' },
  '18170': { x: 468953, y: 4073760, nombre: 'Rubite', provincia: 'Granada' },
  '18171': { x: 405254, y: 4112082, nombre: 'Salar', provincia: 'Granada' },
  '18173': { x: 447607, y: 4066595, nombre: 'Salobreña', provincia: 'Granada' },
  '18174': { x: 413281, y: 4102112, nombre: 'Santa Cruz del Comercio', provincia: 'Granada' },
  '18175': { x: 436110, y: 4115929, nombre: 'Santa Fe', provincia: 'Granada' },
  '18176': { x: 463961, y: 4086953, nombre: 'Soportújar', provincia: 'Granada' },
  '18177': { x: 476204, y: 4072143, nombre: 'Sorvilán', provincia: 'Granada' },
  '18178': { x: 468569, y: 4150919, nombre: 'Torre-Cardela', provincia: 'Granada' },
  '18179': { x: 473411, y: 4081490, nombre: 'Torvizcón', provincia: 'Granada' },
  '18180': { x: 475974, y: 4095319, nombre: 'Trevélez', provincia: 'Granada' },
  '18181': { x: 494940, y: 4079841, nombre: 'Turón', provincia: 'Granada' },
  '18182': { x: 495259, y: 4090799, nombre: 'Ugíjar', provincia: 'Granada' },
  '18183': { x: 492772, y: 4094415, nombre: 'Válor', provincia: 'Granada' },
  '18184': { x: 454068, y: 4076486, nombre: 'Vélez de Benaudalla', provincia: 'Granada' },
  '18185': { x: 426915, y: 4102746, nombre: 'Ventas de Huelma', provincia: 'Granada' },
  '18187': { x: 491970, y: 4156775, nombre: 'Villanueva de las Torres', provincia: 'Granada' },
  '18188': { x: 410183, y: 4119189, nombre: 'Villanueva Mesía', provincia: 'Granada' },
  '18189': { x: 450836, y: 4120787, nombre: 'Víznar', provincia: 'Granada' },
  '18192': { x: 397964, y: 4092818, nombre: 'Zafarraya', provincia: 'Granada' },
  '18193': { x: 448150, y: 4108217, nombre: 'La Zubia', provincia: 'Granada' },
  '18194': { x: 513786, y: 4154720, nombre: 'Zújar', provincia: 'Granada' },
  '18901': { x: 470949, y: 4087820, nombre: 'La Taha', provincia: 'Granada' },
  '18902': { x: 448189, y: 4087143, nombre: 'El Valle', provincia: 'Granada' },
  '18903': { x: 498784, y: 4095860, nombre: 'Nevada', provincia: 'Granada' },
  '18904': { x: 486099, y: 4092928, nombre: 'Alpujarra de la Sierra', provincia: 'Granada' },
  '18905': { x: 440488, y: 4109909, nombre: 'Las Gabias', provincia: 'Granada' },
  '18906': { x: 447971, y: 4077393, nombre: 'Los Guájares', provincia: 'Granada' },
  '18907': { x: 491373, y: 4123589, nombre: 'Valle del Zalabí', provincia: 'Granada' },
  '18908': { x: 447510, y: 4093944, nombre: 'Villamena', provincia: 'Granada' },
  '18909': { x: 470467, y: 4143492, nombre: 'Morelábor', provincia: 'Granada' },
  '18910': { x: 450635, y: 4085185, nombre: 'El Pinar', provincia: 'Granada' },
  '18911': { x: 440944, y: 4114242, nombre: 'Vegas del Genil', provincia: 'Granada' },
  '18912': { x: 506421, y: 4162105, nombre: 'Cuevas del Campo', provincia: 'Granada' },
  '18913': { x: 396262, y: 4123854, nombre: 'Zagra', provincia: 'Granada' },
  '18914': { x: 427309, y: 4121282, nombre: 'Valderrubio', provincia: 'Granada' },
  '18915': { x: 455042, y: 4150173, nombre: 'Domingo Pérez de Granada', provincia: 'Granada' },
  '18916': { x: 456302, y: 4062256, nombre: 'Torrenueva Costa', provincia: 'Granada' },
  '21001': { x: 177656, y: 4198198, nombre: 'Alájar', provincia: 'Huelva' },
  '21002': { x: 143062, y: 4132300, nombre: 'Aljaraque', provincia: 'Huelva' },
  '21003': { x: 122599, y: 4159768, nombre: 'El Almendro', provincia: 'Huelva' },
  '21004': { x: 166804, y: 4198501, nombre: 'Almonaster la Real', provincia: 'Huelva' },
  '21005': { x: 188173, y: 4129547, nombre: 'Almonte', provincia: 'Huelva' },
  '21006': { x: 136345, y: 4163680, nombre: 'Alosno', provincia: 'Huelva' },
  '21007': { x: 186525, y: 4199617, nombre: 'Aracena', provincia: 'Huelva' },
  '21008': { x: 152536, y: 4206925, nombre: 'Aroche', provincia: 'Huelva' },
  '21009': { x: 199610, y: 4214087, nombre: 'Arroyomolinos de León', provincia: 'Huelva' },
  '21010': { x: 109239, y: 4128066, nombre: 'Ayamonte', provincia: 'Huelva' },
  '21011': { x: 164370, y: 4149179, nombre: 'Beas', provincia: 'Huelva' },
  '21012': { x: 187328, y: 4168302, nombre: 'Berrocal', provincia: 'Huelva' },
  '21013': { x: 186373, y: 4138473, nombre: 'Bollullos Par del Condado', provincia: 'Huelva' },
  '21014': { x: 173863, y: 4136961, nombre: 'Bonares', provincia: 'Huelva' },
  '21015': { x: 139729, y: 4183314, nombre: 'Cabezas Rubias', provincia: 'Huelva' },
  '21016': { x: 208698, y: 4207807, nombre: 'Cala', provincia: 'Huelva' },
  '21017': { x: 157717, y: 4174466, nombre: 'Calañas', provincia: 'Huelva' },
  '21018': { x: 179931, y: 4178146, nombre: 'El Campillo', provincia: 'Huelva' },
  '21019': { x: 185106, y: 4185943, nombre: 'Campofrío', provincia: 'Huelva' },
  '21020': { x: 190321, y: 4213224, nombre: 'Cañaveral de León', provincia: 'Huelva' },
  '21021': { x: 131831, y: 4134522, nombre: 'Cartaya', provincia: 'Huelva' },
  '21022': { x: 173955, y: 4200741, nombre: 'Castaño del Robledo', provincia: 'Huelva' },
  '21023': { x: 152896, y: 4183642, nombre: 'El Cerro de Andévalo', provincia: 'Huelva' },
  '21024': { x: 191607, y: 4200112, nombre: 'Corteconcepción', provincia: 'Huelva' },
  '21025': { x: 164046, y: 4202704, nombre: 'Cortegana', provincia: 'Huelva' },
  '21026': { x: 181374, y: 4204867, nombre: 'Cortelazor', provincia: 'Huelva' },
  '21027': { x: 176043, y: 4220349, nombre: 'Cumbres de Enmedio', provincia: 'Huelva' },
  '21028': { x: 171707, y: 4221059, nombre: 'Cumbres de San Bartolomé', provincia: 'Huelva' },
  '21029': { x: 180203, y: 4219029, nombre: 'Cumbres Mayores', provincia: 'Huelva' },
  '21030': { x: 199424, y: 4140589, nombre: 'Chucena', provincia: 'Huelva' },
  '21031': { x: 160706, y: 4228024, nombre: 'Encinasola', provincia: 'Huelva' },
  '21032': { x: 200017, y: 4145629, nombre: 'Escacena del Campo', provincia: 'Huelva' },
  '21033': { x: 178087, y: 4201426, nombre: 'Fuenteheridos', provincia: 'Huelva' },
  '21034': { x: 173985, y: 4204135, nombre: 'Galaroza', provincia: 'Huelva' },
  '21035': { x: 148560, y: 4143988, nombre: 'Gibraleón', provincia: 'Huelva' },
  '21036': { x: 190899, y: 4185973, nombre: 'La Granada de Río-Tinto', provincia: 'Huelva' },
  '21037': { x: 109611, y: 4161814, nombre: 'El Granado', provincia: 'Huelva' },
  '21038': { x: 196684, y: 4193137, nombre: 'Higuera de la Sierra', provincia: 'Huelva' },
  '21039': { x: 184962, y: 4212741, nombre: 'Hinojales', provincia: 'Huelva' },
  '21040': { x: 200458, y: 4132655, nombre: 'Hinojos', provincia: 'Huelva' },
  '21041': { x: 150034, y: 4131291, nombre: 'Huelva', provincia: 'Huelva' },
  '21042': { x: 116668, y: 4125572, nombre: 'Isla Cristina', provincia: 'Huelva' },
  '21043': { x: 172242, y: 4203143, nombre: 'Jabugo', provincia: 'Huelva' },
  '21044': { x: 127080, y: 4131349, nombre: 'Lepe', provincia: 'Huelva' },
  '21045': { x: 181477, y: 4198672, nombre: 'Linares de la Sierra', provincia: 'Huelva' },
  '21046': { x: 169431, y: 4135183, nombre: 'Lucena del Puerto', provincia: 'Huelva' },
  '21047': { x: 196115, y: 4143568, nombre: 'Manzanilla', provincia: 'Huelva' },
  '21048': { x: 181471, y: 4201263, nombre: 'Los Marines', provincia: 'Huelva' },
  '21049': { x: 183067, y: 4177838, nombre: 'Minas de Riotinto', provincia: 'Huelva' },
  '21050': { x: 159109, y: 4131806, nombre: 'Moguer', provincia: 'Huelva' },
  '21051': { x: 170934, y: 4208344, nombre: 'La Nava', provincia: 'Huelva' },
  '21052': { x: 187377, y: 4177856, nombre: 'Nerva', provincia: 'Huelva' },
  '21053': { x: 173972, y: 4141408, nombre: 'Niebla', provincia: 'Huelva' },
  '21054': { x: 185341, y: 4143669, nombre: 'La Palma del Condado', provincia: 'Huelva' },
  '21055': { x: 154300, y: 4127413, nombre: 'Palos de la Frontera', provincia: 'Huelva' },
  '21056': { x: 198858, y: 4147021, nombre: 'Paterna del Campo', provincia: 'Huelva' },
  '21057': { x: 117196, y: 4185910, nombre: 'Paymogo', provincia: 'Huelva' },
  '21058': { x: 125014, y: 4171347, nombre: 'Puebla de Guzmán', provincia: 'Huelva' },
  '21059': { x: 194096, y: 4199546, nombre: 'Puerto Moral', provincia: 'Huelva' },
  '21060': { x: 147592, y: 4122627, nombre: 'Punta Umbría', provincia: 'Huelva' },
  '21061': { x: 181021, y: 4135107, nombre: 'Rociana del Condado', provincia: 'Huelva' },
  '21062': { x: 129187, y: 4210467, nombre: 'Rosal de la Frontera', provincia: 'Huelva' },
  '21063': { x: 136874, y: 4151603, nombre: 'San Bartolomé de la Torre', provincia: 'Huelva' },
  '21064': { x: 159779, y: 4136841, nombre: 'San Juan del Puerto', provincia: 'Huelva' },
  '21065': { x: 105017, y: 4156704, nombre: 'Sanlúcar de Guadiana', provincia: 'Huelva' },
  '21066': { x: 114959, y: 4146849, nombre: 'San Silvestre de Guzmán', provincia: 'Huelva' },
  '21067': { x: 172367, y: 4197283, nombre: 'Santa Ana la Real', provincia: 'Huelva' },
  '21068': { x: 131122, y: 4191543, nombre: 'Santa Bárbara de Casa', provincia: 'Huelva' },
  '21069': { x: 216101, y: 4200430, nombre: 'Santa Olalla del Cala', provincia: 'Huelva' },
  '21070': { x: 160405, y: 4144267, nombre: 'Trigueros', provincia: 'Huelva' },
  '21071': { x: 176274, y: 4206712, nombre: 'Valdelarco', provincia: 'Huelva' },
  '21072': { x: 168513, y: 4165199, nombre: 'Valverde del Camino', provincia: 'Huelva' },
  '21073': { x: 114987, y: 4137417, nombre: 'Villablanca', provincia: 'Huelva' },
  '21074': { x: 192374, y: 4144388, nombre: 'Villalba del Alcor', provincia: 'Huelva' },
  '21075': { x: 144832, y: 4172112, nombre: 'Villanueva de las Cruces', provincia: 'Huelva' },
  '21076': { x: 122187, y: 4158859, nombre: 'Villanueva de los Castillejos', provincia: 'Huelva' },
  '21077': { x: 180753, y: 4144103, nombre: 'Villarrasa', provincia: 'Huelva' },
  '21078': { x: 177299, y: 4176501, nombre: 'Zalamea la Real', provincia: 'Huelva' },
  '21079': { x: 205973, y: 4192625, nombre: 'Zufre', provincia: 'Huelva' },
  '21902': { x: 160053, y: 4181168, nombre: 'La Zarza-Perrunal', provincia: 'Huelva' },
  '23001': { x: 458955, y: 4182794, nombre: 'Albanchez de Mágina', provincia: 'Jaén' },
  '23002': { x: 418228, y: 4146426, nombre: 'Alcalá la Real', provincia: 'Jaén' },
  '23003': { x: 404267, y: 4160965, nombre: 'Alcaudete', provincia: 'Jaén' },
  '23004': { x: 467534, y: 4251534, nombre: 'Aldeaquemada', provincia: 'Jaén' },
  '23005': { x: 407881, y: 4211021, nombre: 'Andújar', provincia: 'Jaén' },
  '23006': { x: 407131, y: 4199200, nombre: 'Arjona', provincia: 'Jaén' },
  '23007': { x: 402819, y: 4203468, nombre: 'Arjonilla', provincia: 'Jaén' },
  '23008': { x: 462306, y: 4225893, nombre: 'Arquillos', provincia: 'Jaén' },
  '23009': { x: 458984, y: 4205588, nombre: 'Baeza', provincia: 'Jaén' },
  '23010': { x: 431755, y: 4216857, nombre: 'Bailén', provincia: 'Jaén' },
  '23011': { x: 432236, y: 4225402, nombre: 'Baños de la Encina', provincia: 'Jaén' },
  '23012': { x: 509563, y: 4233851, nombre: 'Beas de Segura', provincia: 'Jaén' },
  '23014': { x: 453282, y: 4204176, nombre: 'Begíjar', provincia: 'Jaén' },
  '23015': { x: 466339, y: 4175186, nombre: 'Bélmez de la Moraleda', provincia: 'Jaén' },
  '23016': { x: 530468, y: 4245006, nombre: 'Benatae', provincia: 'Jaén' },
  '23017': { x: 474669, y: 4172975, nombre: 'Cabra del Santo Cristo', provincia: 'Jaén' },
  '23018': { x: 450136, y: 4170182, nombre: 'Cambil', provincia: 'Jaén' },
  '23019': { x: 443945, y: 4156558, nombre: 'Campillo de Arenas', provincia: 'Jaén' },
  '23020': { x: 457494, y: 4211019, nombre: 'Canena', provincia: 'Jaén' },
  '23021': { x: 444738, y: 4231581, nombre: 'Carboneros', provincia: 'Jaén' },
  '23024': { x: 446000, y: 4236730, nombre: 'La Carolina', provincia: 'Jaén' },
  '23025': { x: 488586, y: 4233872, nombre: 'Castellar', provincia: 'Jaén' },
  '23026': { x: 416527, y: 4154702, nombre: 'Castillo de Locubín', provincia: 'Jaén' },
  '23027': { x: 422528, y: 4204352, nombre: 'Cazalilla', provincia: 'Jaén' },
  '23028': { x: 499746, y: 4196109, nombre: 'Cazorla', provincia: 'Jaén' },
  '23029': { x: 496072, y: 4240397, nombre: 'Chiclana de Segura', provincia: 'Jaén' },
  '23030': { x: 497271, y: 4205984, nombre: 'Chilluévar', provincia: 'Jaén' },
  '23031': { x: 409099, y: 4192821, nombre: 'Escañuela', provincia: 'Jaén' },
  '23032': { x: 424350, y: 4209706, nombre: 'Espeluy', provincia: 'Jaén' },
  '23033': { x: 425459, y: 4148569, nombre: 'Frailes', provincia: 'Jaén' },
  '23034': { x: 418931, y: 4166766, nombre: 'Fuensanta de Martos', provincia: 'Jaén' },
  '23035': { x: 422312, y: 4192137, nombre: 'Fuerte del Rey', provincia: 'Jaén' },
  '23037': { x: 523291, y: 4253580, nombre: 'Génave', provincia: 'Jaén' },
  '23038': { x: 438863, y: 4177520, nombre: 'La Guardia de Jaén', provincia: 'Jaén' },
  '23039': { x: 439774, y: 4226346, nombre: 'Guarromán', provincia: 'Jaén' },
  '23040': { x: 412875, y: 4203040, nombre: 'Lahiguera', provincia: 'Jaén' },
  '23041': { x: 398047, y: 4184065, nombre: 'Higuera de Calatrava', provincia: 'Jaén' },
  '23042': { x: 500143, y: 4174226, nombre: 'Hinojares', provincia: 'Jaén' },
  '23043': { x: 524655, y: 4229880, nombre: 'Hornos', provincia: 'Jaén' },
  '23044': { x: 459844, y: 4166957, nombre: 'Huelma', provincia: 'Jaén' },
  '23045': { x: 493169, y: 4179549, nombre: 'Huesa', provincia: 'Jaén' },
  '23046': { x: 455979, y: 4208254, nombre: 'Ibros', provincia: 'Jaén' },
  '23047': { x: 500662, y: 4197024, nombre: 'La Iruela', provincia: 'Jaén' },
  '23048': { x: 497138, y: 4223100, nombre: 'Iznatoraf', provincia: 'Jaén' },
  '23049': { x: 436195, y: 4208187, nombre: 'Jabalquinto', provincia: 'Jaén' },
  '23050': { x: 430099, y: 4180791, nombre: 'Jaén', provincia: 'Jaén' },
  '23051': { x: 419686, y: 4178003, nombre: 'Jamilena', provincia: 'Jaén' },
  '23052': { x: 458006, y: 4188354, nombre: 'Jimena', provincia: 'Jaén' },
  '23053': { x: 468902, y: 4188361, nombre: 'Jódar', provincia: 'Jaén' },
  '23054': { x: 482149, y: 4179182, nombre: 'Larva', provincia: 'Jaén' },
  '23055': { x: 444298, y: 4217286, nombre: 'Linares', provincia: 'Jaén' },
  '23056': { x: 393260, y: 4200366, nombre: 'Lopera', provincia: 'Jaén' },
  '23057': { x: 452059, y: 4205681, nombre: 'Lupión', provincia: 'Jaén' },
  '23058': { x: 446271, y: 4181991, nombre: 'Mancha Real', provincia: 'Jaén' },
  '23059': { x: 397325, y: 4211496, nombre: 'Marmolejo', provincia: 'Jaén' },
  '23060': { x: 414464, y: 4175049, nombre: 'Martos', provincia: 'Jaén' },
  '23061': { x: 428997, y: 4202743, nombre: 'Mengíbar', provincia: 'Jaén' },
  '23062': { x: 490829, y: 4243704, nombre: 'Montizón', provincia: 'Jaén' },
  '23063': { x: 472327, y: 4226283, nombre: 'Navas de San Juan', provincia: 'Jaén' },
  '23064': { x: 442338, y: 4153783, nombre: 'Noalejo', provincia: 'Jaén' },
  '23065': { x: 529507, y: 4241239, nombre: 'Orcera', provincia: 'Jaén' },
  '23066': { x: 489379, y: 4196201, nombre: 'Peal de Becerro', provincia: 'Jaén' },
  '23067': { x: 442959, y: 4177158, nombre: 'Pegalajar', provincia: 'Jaén' },
  '23069': { x: 395919, y: 4192226, nombre: 'Porcuna', provincia: 'Jaén' },
  '23070': { x: 505816, y: 4173052, nombre: 'Pozo Alcón', provincia: 'Jaén' },
  '23071': { x: 517210, y: 4244912, nombre: 'Puente de Génave', provincia: 'Jaén' },
  '23072': { x: 522820, y: 4244393, nombre: 'La Puerta de Segura', provincia: 'Jaén' },
  '23073': { x: 494084, y: 4188414, nombre: 'Quesada', provincia: 'Jaén' },
  '23074': { x: 459518, y: 4211172, nombre: 'Rus', provincia: 'Jaén' },
  '23075': { x: 472652, y: 4213378, nombre: 'Sabiote', provincia: 'Jaén' },
  '23076': { x: 452923, y: 4243751, nombre: 'Santa Elena', provincia: 'Jaén' },
  '23077': { x: 396902, y: 4179157, nombre: 'Santiago de Calatrava', provincia: 'Jaén' },
  '23079': { x: 482006, y: 4233508, nombre: 'Santisteban del Puerto', provincia: 'Jaén' },
  '23080': { x: 491116, y: 4208811, nombre: 'Santo Tomé', provincia: 'Jaén' },
  '23081': { x: 530487, y: 4238933, nombre: 'Segura de la Sierra', provincia: 'Jaén' },
  '23082': { x: 536498, y: 4248903, nombre: 'Siles', provincia: 'Jaén' },
  '23084': { x: 495228, y: 4232592, nombre: 'Sorihuela del Guadalimar', provincia: 'Jaén' },
  '23085': { x: 443944, y: 4205722, nombre: 'Torreblascopedro', provincia: 'Jaén' },
  '23086': { x: 420973, y: 4180665, nombre: 'Torredelcampo', provincia: 'Jaén' },
  '23087': { x: 415830, y: 4180315, nombre: 'Torredonjimeno', provincia: 'Jaén' },
  '23088': { x: 474674, y: 4209818, nombre: 'Torreperogil', provincia: 'Jaén' },
  '23090': { x: 455206, y: 4182093, nombre: 'Torres', provincia: 'Jaén' },
  '23091': { x: 528087, y: 4251942, nombre: 'Torres de Albánchez', provincia: 'Jaén' },
  '23092': { x: 467440, y: 4207312, nombre: 'Úbeda', provincia: 'Jaén' },
  '23093': { x: 427599, y: 4160360, nombre: 'Valdepeñas de Jaén', provincia: 'Jaén' },
  '23094': { x: 455336, y: 4228978, nombre: 'Vilches', provincia: 'Jaén' },
  '23095': { x: 492507, y: 4218529, nombre: 'Villacarrillo', provincia: 'Jaén' },
  '23096': { x: 419542, y: 4206895, nombre: 'Villanueva de la Reina', provincia: 'Jaén' },
  '23097': { x: 499516, y: 4224585, nombre: 'Villanueva del Arzobispo', provincia: 'Jaén' },
  '23098': { x: 411848, y: 4188324, nombre: 'Villardompardo', provincia: 'Jaén' },
  '23099': { x: 428241, y: 4171799, nombre: 'Los Villares', provincia: 'Jaén' },
  '23101': { x: 531679, y: 4259984, nombre: 'Villarrodrigo', provincia: 'Jaén' },
  '23901': { x: 443506, y: 4165791, nombre: 'Cárcheles', provincia: 'Jaén' },
  '23902': { x: 463724, y: 4186126, nombre: 'Bedmar y Garcíez', provincia: 'Jaén' },
  '23903': { x: 435946, y: 4199440, nombre: 'Villatorres', provincia: 'Jaén' },
  '23904': { x: 539191, y: 4218287, nombre: 'Santiago-Pontones', provincia: 'Jaén' },
  '23905': { x: 509126, y: 4241429, nombre: 'Arroyo del Ojanco', provincia: 'Jaén' },
  '29001': { x: 352857, y: 4119009, nombre: 'Alameda', provincia: 'Málaga' },
  '29002': { x: 400703, y: 4084720, nombre: 'Alcaucín', provincia: 'Málaga' },
  '29003': { x: 387848, y: 4094960, nombre: 'Alfarnate', provincia: 'Málaga' },
  '29004': { x: 386718, y: 4093290, nombre: 'Alfarnatejo', provincia: 'Málaga' },
  '29005': { x: 407145, y: 4070118, nombre: 'Algarrobo', provincia: 'Málaga' },
  '29006': { x: 296439, y: 4050044, nombre: 'Algatocín', provincia: 'Málaga' },
  '29007': { x: 360142, y: 4058444, nombre: 'Alhaurín de la Torre', provincia: 'Málaga' },
  '29008': { x: 349212, y: 4056648, nombre: 'Alhaurín el Grande', provincia: 'Málaga' },
  '29009': { x: 391416, y: 4074192, nombre: 'Almáchar', provincia: 'Málaga' },
  '29010': { x: 319790, y: 4097100, nombre: 'Almargen', provincia: 'Málaga' },
  '29011': { x: 362624, y: 4076898, nombre: 'Almogía', provincia: 'Málaga' },
  '29012': { x: 347838, y: 4076790, nombre: 'Álora', provincia: 'Málaga' },
  '29013': { x: 333956, y: 4066326, nombre: 'Alozaina', provincia: 'Málaga' },
  '29014': { x: 303093, y: 4056541, nombre: 'Alpandeire', provincia: 'Málaga' },
  '29015': { x: 361103, y: 4098076, nombre: 'Antequera', provincia: 'Málaga' },
  '29016': { x: 411687, y: 4077382, nombre: 'Árchez', provincia: 'Málaga' },
  '29017': { x: 376737, y: 4106345, nombre: 'Archidona', provincia: 'Málaga' },
  '29018': { x: 335569, y: 4082860, nombre: 'Ardales', provincia: 'Málaga' },
  '29019': { x: 406820, y: 4074976, nombre: 'Arenas', provincia: 'Málaga' },
  '29020': { x: 308650, y: 4074591, nombre: 'Arriate', provincia: 'Málaga' },
  '29021': { x: 299306, y: 4057281, nombre: 'Atajate', provincia: 'Málaga' },
  '29022': { x: 297171, y: 4053695, nombre: 'Benadalid', provincia: 'Málaga' },
  '29023': { x: 316874, y: 4043903, nombre: 'Benahavís', provincia: 'Málaga' },
  '29024': { x: 297739, y: 4052238, nombre: 'Benalauría', provincia: 'Málaga' },
  '29025': { x: 359832, y: 4050986, nombre: 'Benalmádena', provincia: 'Málaga' },
  '29026': { x: 393612, y: 4077232, nombre: 'Benamargosa', provincia: 'Málaga' },
  '29027': { x: 396308, y: 4072301, nombre: 'Benamocarra', provincia: 'Málaga' },
  '29028': { x: 298845, y: 4066027, nombre: 'Benaoján', provincia: 'Málaga' },
  '29029': { x: 296297, y: 4047502, nombre: 'Benarrabá', provincia: 'Málaga' },
  '29030': { x: 389871, y: 4075028, nombre: 'El Borge', provincia: 'Málaga' },
  '29031': { x: 326299, y: 4073353, nombre: 'El Burgo', provincia: 'Málaga' },
  '29032': { x: 334419, y: 4101683, nombre: 'Campillos', provincia: 'Málaga' },
  '29033': { x: 403446, y: 4081398, nombre: 'Canillas de Aceituno', provincia: 'Málaga' },
  '29034': { x: 412045, y: 4078188, nombre: 'Canillas de Albaida', provincia: 'Málaga' },
  '29035': { x: 319731, y: 4091481, nombre: 'Cañete la Real', provincia: 'Málaga' },
  '29036': { x: 337692, y: 4080038, nombre: 'Carratraca', provincia: 'Málaga' },
  '29037': { x: 307447, y: 4057750, nombre: 'Cartajima', provincia: 'Málaga' },
  '29038': { x: 354302, y: 4063942, nombre: 'Cártama', provincia: 'Málaga' },
  '29039': { x: 372481, y: 4084015, nombre: 'Casabermeja', provincia: 'Málaga' },
  '29040': { x: 335588, y: 4072785, nombre: 'Casarabonela', provincia: 'Málaga' },
  '29041': { x: 296385, y: 4035692, nombre: 'Casares', provincia: 'Málaga' },
  '29042': { x: 342885, y: 4058663, nombre: 'Coín', provincia: 'Málaga' },
  '29043': { x: 380748, y: 4085024, nombre: 'Colmenar', provincia: 'Málaga' },
  '29044': { x: 388760, y: 4078891, nombre: 'Comares', provincia: 'Málaga' },
  '29045': { x: 413188, y: 4076840, nombre: 'Cómpeta', provincia: 'Málaga' },
  '29046': { x: 290587, y: 4055013, nombre: 'Cortes de la Frontera', provincia: 'Málaga' },
  '29047': { x: 368184, y: 4121833, nombre: 'Cuevas Bajas', provincia: 'Málaga' },
  '29048': { x: 317683, y: 4082872, nombre: 'Cuevas del Becerro', provincia: 'Málaga' },
  '29049': { x: 374688, y: 4125555, nombre: 'Cuevas de San Marcos', provincia: 'Málaga' },
  '29050': { x: 390458, y: 4076823, nombre: 'Cútar', provincia: 'Málaga' },
  '29051': { x: 306545, y: 4032976, nombre: 'Estepona', provincia: 'Málaga' },
  '29052': { x: 304380, y: 4054508, nombre: 'Faraján', provincia: 'Málaga' },
  '29053': { x: 420031, y: 4071834, nombre: 'Frigiliana', provincia: 'Málaga' },
  '29054': { x: 353880, y: 4043357, nombre: 'Fuengirola', provincia: 'Málaga' },
  '29055': { x: 346231, y: 4111431, nombre: 'Fuente de Piedra', provincia: 'Málaga' },
  '29056': { x: 292441, y: 4044006, nombre: 'Gaucín', provincia: 'Málaga' },
  '29057': { x: 299946, y: 4046783, nombre: 'Genalguacil', provincia: 'Málaga' },
  '29058': { x: 336045, y: 4058342, nombre: 'Guaro', provincia: 'Málaga' },
  '29059': { x: 348927, y: 4109014, nombre: 'Humilladero', provincia: 'Málaga' },
  '29060': { x: 310387, y: 4056080, nombre: 'Igualeja', provincia: 'Málaga' },
  '29061': { x: 325611, y: 4050259, nombre: 'Istán', provincia: 'Málaga' },
  '29062': { x: 394281, y: 4070661, nombre: 'Iznate', provincia: 'Málaga' },
  '29063': { x: 296655, y: 4058566, nombre: 'Jimera de Líbar', provincia: 'Málaga' },
  '29064': { x: 301678, y: 4048896, nombre: 'Jubrique', provincia: 'Málaga' },
  '29065': { x: 305937, y: 4055428, nombre: 'Júzcar', provincia: 'Málaga' },
  '29066': { x: 391659, y: 4069212, nombre: 'Macharaviaya', provincia: 'Málaga' },
  '29067': { x: 372499, y: 4065556, nombre: 'Málaga', provincia: 'Málaga' },
  '29068': { x: 298259, y: 4027855, nombre: 'Manilva', provincia: 'Málaga' },
  '29069': { x: 328525, y: 4042967, nombre: 'Marbella', provincia: 'Málaga' },
  '29070': { x: 353368, y: 4051145, nombre: 'Mijas', provincia: 'Málaga' },
  '29071': { x: 388037, y: 4070219, nombre: 'Moclinejo', provincia: 'Málaga' },
  '29072': { x: 352625, y: 4110248, nombre: 'Mollina', provincia: 'Málaga' },
  '29073': { x: 336175, y: 4055347, nombre: 'Monda', provincia: 'Málaga' },
  '29074': { x: 299036, y: 4067861, nombre: 'Montejaque', provincia: 'Málaga' },
  '29075': { x: 422250, y: 4068029, nombre: 'Nerja', provincia: 'Málaga' },
  '29076': { x: 333932, y: 4048207, nombre: 'Ojén', provincia: 'Málaga' },
  '29077': { x: 309656, y: 4058849, nombre: 'Parauta', provincia: 'Málaga' },
  '29079': { x: 393895, y: 4087588, nombre: 'Periana', provincia: 'Málaga' },
  '29080': { x: 347685, y: 4070119, nombre: 'Pizarra', provincia: 'Málaga' },
  '29081': { x: 307698, y: 4054038, nombre: 'Pujerra', provincia: 'Málaga' },
  '29082': { x: 385110, y: 4064546, nombre: 'Rincón de la Victoria', provincia: 'Málaga' },
  '29083': { x: 384930, y: 4086519, nombre: 'Riogordo', provincia: 'Málaga' },
  '29084': { x: 306809, y: 4068204, nombre: 'Ronda', provincia: 'Málaga' },
  '29085': { x: 408651, y: 4079214, nombre: 'Salares', provincia: 'Málaga' },
  '29086': { x: 409626, y: 4072962, nombre: 'Sayalonga', provincia: 'Málaga' },
  '29087': { x: 407810, y: 4080073, nombre: 'Sedella', provincia: 'Málaga' },
  '29088': { x: 334201, y: 4110317, nombre: 'Sierra de Yeguas', provincia: 'Málaga' },
  '29089': { x: 329196, y: 4094669, nombre: 'Teba', provincia: 'Málaga' },
  '29090': { x: 329818, y: 4061697, nombre: 'Tolox', provincia: 'Málaga' },
  '29091': { x: 414875, y: 4068289, nombre: 'Torrox', provincia: 'Málaga' },
  '29092': { x: 384210, y: 4069632, nombre: 'Totalán', provincia: 'Málaga' },
  '29093': { x: 350229, y: 4088658, nombre: 'Valle de Abdalajís', provincia: 'Málaga' },
  '29094': { x: 401682, y: 4070982, nombre: 'Vélez-Málaga', provincia: 'Málaga' },
  '29095': { x: 371205, y: 4116370, nombre: 'Villanueva de Algaidas', provincia: 'Málaga' },
  '29096': { x: 378502, y: 4095561, nombre: 'Villanueva del Rosario', provincia: 'Málaga' },
  '29097': { x: 380912, y: 4098744, nombre: 'Villanueva del Trabuco', provincia: 'Málaga' },
  '29098': { x: 381494, y: 4115919, nombre: 'Villanueva de Tapia', provincia: 'Málaga' },
  '29099': { x: 398181, y: 4080355, nombre: 'Viñuela', provincia: 'Málaga' },
  '29100': { x: 328474, y: 4067007, nombre: 'Yunquera', provincia: 'Málaga' },
  '29901': { x: 365862, y: 4054834, nombre: 'Torremolinos', provincia: 'Málaga' },
  '29902': { x: 363693, y: 4088226, nombre: 'Villanueva de la Concepción', provincia: 'Málaga' },
  '29903': { x: 294956, y: 4076882, nombre: 'Montecorto', provincia: 'Málaga' },
  '29904': { x: 323356, y: 4083995, nombre: 'Serrato', provincia: 'Málaga' },
  '41001': { x: 323271, y: 4124865, nombre: 'Aguadulce', provincia: 'Sevilla' },
  '41002': { x: 261887, y: 4213498, nombre: 'Alanís', provincia: 'Sevilla' },
  '41003': { x: 219831, y: 4146727, nombre: 'Albaida del Aljarafe', provincia: 'Sevilla' },
  '41004': { x: 247666, y: 4135645, nombre: 'Alcalá de Guadaíra', provincia: 'Sevilla' },
  '41005': { x: 236224, y: 4156248, nombre: 'Alcalá del Río', provincia: 'Sevilla' },
  '41006': { x: 264472, y: 4166572, nombre: 'Alcolea del Río', provincia: 'Sevilla' },
  '41007': { x: 233562, y: 4150748, nombre: 'La Algaba', provincia: 'Sevilla' },
  '41008': { x: 308813, y: 4098677, nombre: 'Algámitas', provincia: 'Sevilla' },
  '41009': { x: 228887, y: 4196227, nombre: 'Almadén de la Plata', provincia: 'Sevilla' },
  '41010': { x: 224219, y: 4133880, nombre: 'Almensilla', provincia: 'Sevilla' },
  '41011': { x: 274298, y: 4126969, nombre: 'Arahal', provincia: 'Sevilla' },
  '41012': { x: 211929, y: 4133597, nombre: 'Aznalcázar', provincia: 'Sevilla' },
  '41013': { x: 210945, y: 4157666, nombre: 'Aznalcóllar', provincia: 'Sevilla' },
  '41014': { x: 351713, y: 4130024, nombre: 'Badolatosa', provincia: 'Sevilla' },
  '41015': { x: 216917, y: 4138863, nombre: 'Benacazón', provincia: 'Sevilla' },
  '41016': { x: 221788, y: 4137331, nombre: 'Bollullos de la Mitación', provincia: 'Sevilla' },
  '41017': { x: 227605, y: 4140336, nombre: 'Bormujos', provincia: 'Sevilla' },
  '41018': { x: 246199, y: 4159749, nombre: 'Brenes', provincia: 'Sevilla' },
  '41019': { x: 237648, y: 4164173, nombre: 'Burguillos', provincia: 'Sevilla' },
  '41020': { x: 238470, y: 4097170, nombre: 'Las Cabezas de San Juan', provincia: 'Sevilla' },
  '41021': { x: 231036, y: 4143690, nombre: 'Camas', provincia: 'Sevilla' },
  '41022': { x: 285568, y: 4160777, nombre: 'La Campana', provincia: 'Sevilla' },
  '41023': { x: 250743, y: 4166415, nombre: 'Cantillana', provincia: 'Sevilla' },
  '41024': { x: 266152, y: 4150539, nombre: 'Carmona', provincia: 'Sevilla' },
  '41025': { x: 205059, y: 4141081, nombre: 'Carrión de los Céspedes', provincia: 'Sevilla' },
  '41026': { x: 343423, y: 4129139, nombre: 'Casariche', provincia: 'Sevilla' },
  '41027': { x: 236506, y: 4174037, nombre: 'Castilblanco de los Arroyos', provincia: 'Sevilla' },
  '41028': { x: 229390, y: 4144582, nombre: 'Castilleja de Guzmán', provincia: 'Sevilla' },
  '41029': { x: 229100, y: 4141467, nombre: 'Castilleja de la Cuesta', provincia: 'Sevilla' },
  '41030': { x: 204701, y: 4143019, nombre: 'Castilleja del Campo', provincia: 'Sevilla' },
  '41031': { x: 207683, y: 4176919, nombre: 'El Castillo de las Guardas', provincia: 'Sevilla' },
  '41032': { x: 257522, y: 4201839, nombre: 'Cazalla de la Sierra', provincia: 'Sevilla' },
  '41033': { x: 269551, y: 4194886, nombre: 'Constantina', provincia: 'Sevilla' },
  '41034': { x: 228964, y: 4130893, nombre: 'Coria del Río', provincia: 'Sevilla' },
  '41035': { x: 282773, y: 4094704, nombre: 'Coripe', provincia: 'Sevilla' },
  '41036': { x: 265749, y: 4106789, nombre: 'El Coronil', provincia: 'Sevilla' },
  '41037': { x: 323719, y: 4107582, nombre: 'Los Corrales', provincia: 'Sevilla' },
  '41038': { x: 240704, y: 4129772, nombre: 'Dos Hermanas', provincia: 'Sevilla' },
  '41039': { x: 316283, y: 4157086, nombre: 'Écija', provincia: 'Sevilla' },
  '41040': { x: 223076, y: 4141851, nombre: 'Espartinas', provincia: 'Sevilla' },
  '41041': { x: 333317, y: 4128697, nombre: 'Estepa', provincia: 'Sevilla' },
  '41042': { x: 292499, y: 4149222, nombre: 'Fuentes de Andalucía', provincia: 'Sevilla' },
  '41043': { x: 220075, y: 4169049, nombre: 'El Garrobo', provincia: 'Sevilla' },
  '41044': { x: 231872, y: 4136851, nombre: 'Gelves', provincia: 'Sevilla' },
  '41045': { x: 221074, y: 4158348, nombre: 'Gerena', provincia: 'Sevilla' },
  '41046': { x: 329945, y: 4124310, nombre: 'Gilena', provincia: 'Sevilla' },
  '41047': { x: 227451, y: 4142352, nombre: 'Gines', provincia: 'Sevilla' },
  '41048': { x: 252820, y: 4219832, nombre: 'Guadalcanal', provincia: 'Sevilla' },
  '41049': { x: 230097, y: 4159380, nombre: 'Guillena', provincia: 'Sevilla' },
  '41050': { x: 336270, y: 4136685, nombre: 'Herrera', provincia: 'Sevilla' },
  '41051': { x: 209760, y: 4139434, nombre: 'Huévar del Aljarafe', provincia: 'Sevilla' },
  '41052': { x: 302973, y: 4136430, nombre: 'Lantejuela', provincia: 'Sevilla' },
  '41053': { x: 226046, y: 4090137, nombre: 'Lebrija', provincia: 'Sevilla' },
  '41054': { x: 338217, y: 4126419, nombre: 'Lora de Estepa', provincia: 'Sevilla' },
  '41055': { x: 277017, y: 4170708, nombre: 'Lora del Río', provincia: 'Sevilla' },
  '41056': { x: 301121, y: 4155576, nombre: 'La Luisiana', provincia: 'Sevilla' },
  '41057': { x: 190132, y: 4172348, nombre: 'El Madroño', provincia: 'Sevilla' },
  '41058': { x: 256429, y: 4139978, nombre: 'Mairena del Alcor', provincia: 'Sevilla' },
  '41059': { x: 229883, y: 4137016, nombre: 'Mairena del Aljarafe', provincia: 'Sevilla' },
  '41060': { x: 285926, y: 4134109, nombre: 'Marchena', provincia: 'Sevilla' },
  '41061': { x: 326862, y: 4138024, nombre: 'Marinaleda', provincia: 'Sevilla' },
  '41062': { x: 325751, y: 4108694, nombre: 'Martín de la Jara', provincia: 'Sevilla' },
  '41063': { x: 258500, y: 4115644, nombre: 'Los Molares', provincia: 'Sevilla' },
  '41064': { x: 271355, y: 4097370, nombre: 'Montellano', provincia: 'Sevilla' },
  '41065': { x: 281967, y: 4111172, nombre: 'Morón de la Frontera', provincia: 'Sevilla' },
  '41066': { x: 283394, y: 4201170, nombre: 'Las Navas de la Concepción', provincia: 'Sevilla' },
  '41067': { x: 220360, y: 4145673, nombre: 'Olivares', provincia: 'Sevilla' },
  '41068': { x: 313524, y: 4123356, nombre: 'Osuna', provincia: 'Sevilla' },
  '41069': { x: 240697, y: 4116887, nombre: 'Los Palacios y Villafranca', provincia: 'Sevilla' },
  '41070': { x: 228441, y: 4134803, nombre: 'Palomares del Río', provincia: 'Sevilla' },
  '41071': { x: 278823, y: 4129947, nombre: 'Paradas', provincia: 'Sevilla' },
  '41072': { x: 331908, y: 4121406, nombre: 'Pedrera', provincia: 'Sevilla' },
  '41073': { x: 256629, y: 4191840, nombre: 'El Pedroso', provincia: 'Sevilla' },
  '41074': { x: 293178, y: 4176160, nombre: 'Peñaflor', provincia: 'Sevilla' },
  '41075': { x: 207118, y: 4133616, nombre: 'Pilas', provincia: 'Sevilla' },
  '41076': { x: 302248, y: 4094127, nombre: 'Pruna', provincia: 'Sevilla' },
  '41077': { x: 294806, y: 4121950, nombre: 'La Puebla de Cazalla', provincia: 'Sevilla' },
  '41078': { x: 289696, y: 4184227, nombre: 'La Puebla de los Infantes', provincia: 'Sevilla' },
  '41079': { x: 228121, y: 4128865, nombre: 'La Puebla del Río', provincia: 'Sevilla' },
  '41080': { x: 222913, y: 4204856, nombre: 'El Real de la Jara', provincia: 'Sevilla' },
  '41081': { x: 236443, y: 4153109, nombre: 'La Rinconada', provincia: 'Sevilla' },
  '41082': { x: 342095, y: 4118577, nombre: 'La Roda de Andalucía', provincia: 'Sevilla' },
  '41083': { x: 220007, y: 4180142, nombre: 'El Ronquillo', provincia: 'Sevilla' },
  '41084': { x: 323685, y: 4136095, nombre: 'El Rubio', provincia: 'Sevilla' },
  '41085': { x: 224611, y: 4146021, nombre: 'Salteras', provincia: 'Sevilla' },
  '41086': { x: 231561, y: 4139164, nombre: 'San Juan de Aznalfarache', provincia: 'Sevilla' },
  '41087': { x: 216473, y: 4142554, nombre: 'Sanlúcar la Mayor', provincia: 'Sevilla' },
  '41088': { x: 267226, y: 4208495, nombre: 'San Nicolás del Puerto', provincia: 'Sevilla' },
  '41089': { x: 230824, y: 4147643, nombre: 'Santiponce', provincia: 'Sevilla' },
  '41090': { x: 313562, y: 4104727, nombre: 'El Saucejo', provincia: 'Sevilla' },
  '41091': { x: 233731, y: 4140452, nombre: 'Sevilla', provincia: 'Sevilla' },
  '41092': { x: 258655, y: 4166085, nombre: 'Tocina', provincia: 'Sevilla' },
  '41093': { x: 230150, y: 4140728, nombre: 'Tomares', provincia: 'Sevilla' },
  '41094': { x: 220216, y: 4140337, nombre: 'Umbrete', provincia: 'Sevilla' },
  '41095': { x: 253270, y: 4118909, nombre: 'Utrera', provincia: 'Sevilla' },
  '41096': { x: 227938, y: 4145442, nombre: 'Valencina de la Concepción', provincia: 'Sevilla' },
  '41097': { x: 206686, y: 4127293, nombre: 'Villamanrique de la Condesa', provincia: 'Sevilla' },
  '41098': { x: 221685, y: 4143691, nombre: 'Villanueva del Ariscal', provincia: 'Sevilla' },
  '41099': { x: 260599, y: 4170734, nombre: 'Villanueva del Río y Minas', provincia: 'Sevilla' },
  '41100': { x: 306579, y: 4102643, nombre: 'Villanueva de San Juan', provincia: 'Sevilla' },
  '41101': { x: 246179, y: 4164070, nombre: 'Villaverde del Río', provincia: 'Sevilla' },
  '41102': { x: 259296, y: 4141696, nombre: 'El Viso del Alcor', provincia: 'Sevilla' },
  '41901': { x: 305048, y: 4163452, nombre: 'Cañada Rosal', provincia: 'Sevilla' },
  '41902': { x: 218943, y: 4114275, nombre: 'Isla Mayor', provincia: 'Sevilla' },
  '41903': { x: 229163, y: 4083013, nombre: 'El Cuervo de Sevilla', provincia: 'Sevilla' },
  '41904': { x: 250684, y: 4105494, nombre: 'El Palmar de Troya', provincia: 'Sevilla' }
};

/**
 * Obtiene el centroide de un municipio por código INE
 */
export function getCentroidePorINE(codigoINE: string): CentroideMunicipio | null {
  const cod = codigoINE.padStart(5, '0');
  return CENTROIDES_MUNICIPIOS[cod] || null;
}

/**
 * Busca un municipio por nombre (normalizado)
 */
export function buscarMunicipioPorNombre(nombre: string): { codigo: string; centroide: CentroideMunicipio } | null {
  const nombreNorm = nombre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  for (const [codigo, centroide] of Object.entries(CENTROIDES_MUNICIPIOS)) {
    const nombreMuniNorm = centroide.nombre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (nombreMuniNorm === nombreNorm || nombreMuniNorm.includes(nombreNorm) || nombreNorm.includes(nombreMuniNorm)) {
      return { codigo, centroide };
    }
  }
  return null;
}

/**
 * Lista municipios de una provincia
 */
export function getMunicipiosPorProvincia(provincia: string): Array<{ codigo: string; centroide: CentroideMunicipio }> {
  const provNorm = provincia.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return Object.entries(CENTROIDES_MUNICIPIOS)
    .filter(([_, c]) => c.provincia.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(provNorm))
    .map(([codigo, centroide]) => ({ codigo, centroide }));
}

// Estadísticas
export const TOTAL_MUNICIPIOS = 785;

export const MUNICIPIOS_POR_PROVINCIA = {
  'Almería': 103,
  'Cádiz': 45,
  'Córdoba': 77,
  'Granada': 174,
  'Huelva': 80,
  'Jaén': 97,
  'Málaga': 103,
  'Sevilla': 106,
} as const;

export default CENTROIDES_MUNICIPIOS;
